export const buttons = [
  {
    id: "ac",
    title: "AC",
    value: "ac",
    action: "ALL_CLEAR",
    color: "primary"
  },
  {
    id: "append",
    title: "<=",
    value: "undo",
    action: "INPUT_UNDO",
    color: "primary",
  },
  {
    id: "modulo",
    title: "%",
    value: "%",
    action: "INPUT_ACTION",
    color: "primary",
  },
  {
    id: "divide",
    title: "/",
    value: "/",
    action: "INPUT_ACTION",
    color: "primary",
  },
  {
    id: "seven",
    title: "7",
    value: "7",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "eight",
    title: "8",
    value: "8",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "nine",
    title: "9",
    value: "9",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "multiply",
    title: "X",
    value: "*",
    action: "INPUT_ACTION",
    color: "primary",
  },
  {
    id: "four",
    title: "4",
    value: "4",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "five",
    title: "5",
    value: "5",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "six",
    title: "6",
    value: "6",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "minus",
    title: "-",
    value: "-",
    action: "INPUT_ACTION",
    color: "primary",
  },
  {
    id: "one",
    title: "1",
    value: "1",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "two",
    title: "2",
    value: "2",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "three",
    title: "3",
    value: "3",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "plus",
    title: "+",
    value: "+",
    action: "INPUT_ACTION",
    color: "primary",
  },
  {
    id: "zero",
    title: "0",
    value: "0",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "dot",
    title: ".",
    value: ".",
    action: "INPUT_NUMBER",
    color: "secondary",
  },
  {
    id: "equalto",
    title: "=",
    value: "=",
    action: "SHOW_RESULT",
    color: "primary",
  },
];
